import React, { useEffect, useState } from "react";
import $ from 'jquery';

import { LinkProvider } from './LinkProvider'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { images } from "./imagesToLoad";

import Header from './components/Header'
import Footer from './components/Footer'

import Home from './pages/Home'
import TradingProducts from "./pages/TradingProducts";
import Trading from "./pages/TradingTools";
import AccountTypes from "./pages/AccountTypes";
import AboutUs from "./pages/AboutUs";

function App() {
  const [ isLoading, setIsLoading ] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => {
        resolve(image);
      }
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    isLoading && $('body').addClass("ovf-hidden");
    Promise
      .all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err)
        setIsLoading(false);
      });
    // eslint-disable-next-line  
  }, []);

  useEffect(() => {
    !isLoading && $('body').removeClass("ovf-hidden");
    !isLoading && $('#loader').addClass("hide");
  }, [isLoading]); 
  return (
    <Router>
      <LinkProvider>
        <Header/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tradingproducts" element={<TradingProducts />} />
            <Route path="/tradingtools" element={<Trading />} />
            <Route path="/accounts" element={<AccountTypes />} />
            <Route path="/aboutus" element={<AboutUs />} />
          </Routes>
        <Footer/>
      </LinkProvider>
    </Router>
  );
}

export default App;